module.exports = __webpack_public_path__ + "img/hof_7.fee6c9e6.jpg";